import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerAircraftNote } from '../models/customer-aircraft-note';
import { Observable } from 'rxjs';
import { CustomerAircraft } from '../models/customer-aircraft';

@Injectable()
export class CustomeraircraftsService {
    private headers: HttpHeaders;
    private accessPointUrl: string;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string , private route : ActivatedRoute) {
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8',
        });
        this.accessPointUrl = baseUrl + 'api/customeraircrafts';
    }

    public getCustomerAircraftsByGroupAndCustomerId(
        groupId,
        fboId,
        customerId
    ): Observable<any> {
        return this.http.get(
            this.accessPointUrl +
                '/group/' +
                groupId +
                '/fbo/' +
                fboId +
                '/customer/' +
                customerId,
            {
                headers: this.headers,
            }
        );
    }

    public getCustomerAircraftsByGroup(groupId): Observable<any> {
        return this.http.get(this.accessPointUrl + '/group/' + groupId, {
            headers: this.headers,
        });
    }

    public getCustomerAircraftsByGroupAndFbo(groupId, fboId): Observable<any> {
        return this.http.get(
            this.accessPointUrl + '/group/' + groupId + '/fbo/' + fboId,
            {
                headers: this.headers,
            }
        );
    }

    public getAircraftsListByGroupAndFbo(groupId, fboId): Observable<any> {
        return this.http.get(
            this.accessPointUrl +
                '/group/' +
                groupId +
                '/fbo/' +
                fboId +
                '/list',
            {
                headers: this.headers,
            }
        );
    }

    public getCustomerAircraftsCountByGroupId(groupId): Observable<any> {
        return this.http.get(
            this.accessPointUrl + '/group/' + groupId + '/count',
            {
                headers: this.headers,
            }
        );
    }

    public get(payload): Observable<CustomerAircraft> {
        return this.http.get<CustomerAircraft>(this.accessPointUrl + '/' + payload.oid, {
            headers: this.headers,
        });
    }

    public add(payload , userId, fboId: number = 0, isFavorite: boolean = false ): Observable<any> {
        return this.http.post(`${this.accessPointUrl}/${userId}/?isFavorite=${isFavorite}&fboId=${fboId}`, payload, {
            headers: this.headers,
        });
    }

    public addMultipleWithTemplate(groupId, fboId, customerId, payload): Observable<any> {
        return this.http.post(
            `${this.accessPointUrl}/group/${groupId}/fbo/${fboId}/customer/${customerId}/multiple`,
            payload,
            {
                headers: this.headers,
            }
        );
    }

    public import(payload): Observable<any> {
        return this.http.post(this.accessPointUrl+'/import', payload, {
            headers: this.headers,
        });
    }

    public remove(payload , userId): Observable<any> {
        return this.http.delete(this.accessPointUrl + '/' + payload.oid+'/'+userId, {
            headers: this.headers,
        });
    }

    public update(payload , userId): Observable<CustomerAircraft> {
        return this.http.put<CustomerAircraft>(this.accessPointUrl + '/' + payload.oid+'/'+userId, payload, {
            headers: this.headers,
        });
    }

    public updateTemplate(fboid, payload): Observable<any> {
        return this.http.put(this.accessPointUrl + '/fbo/' + fboid, payload, {
            headers: this.headers,
        });
    }

    public createAircraftWithCustomer(payload): Observable<any> {
        return this.http.post(
            this.accessPointUrl + '/create-with-customer',
            payload,
            {
                headers: this.headers,
            }
        );
    }

    public getCustomerAircraftNotes(customerAircraftId: number): Observable<any> {
        return this.http.get(
            this.accessPointUrl + '/notes/' + customerAircraftId,
            {
                headers: this.headers,
            }
        );
    }

    public getCustomerAircraftNotesByTailNumberGroupIdCustomerId(tailNumber: string, groupId: number, customerId: number): Observable<any> {
        return this.http.get(
            this.accessPointUrl + '/notes/tailnumber/' + tailNumber + '/groupId/' + groupId + '/customerid/' + customerId,
            {
                headers: this.headers,
            }
        );
    }

    public addCustomerAircraftNotes(payload: CustomerAircraftNote): Observable<any> {
        return this.http.post(this.accessPointUrl + '/notes', payload, {
            headers: this.headers,
        });
    }

    public updateCustomerAircraftNotes(payload: CustomerAircraftNote): Observable<any> {
        return this.http.put(this.accessPointUrl + '/notes/' + payload.oid, payload, {
            headers: this.headers,
        });
    }

    public deleteCustomerAircraftNotes(id: number): Observable<any> {
        return this.http.delete(
            this.accessPointUrl + '/notes/' + id,
            {
                headers: this.headers,
            }
        );
    }
}
